// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"881":"71fd6467","977":"f1d186e3"}[chunkId] + ".css";
};